<template>
  <div
    id="mapDesktop"
    style="z-index: 99;"
  >

    <b-card
      v-if="isMobile"
      title=""
      class="reportDiv"
      style="display: none"
    >
      <div
        style="display: flex;padding: 10px 5px;direction: ltr;"
      >
        <b-form-textarea
          ref="mytextarea"
          v-model="reportLog"
          rows="5"
        />
      </div>
    </b-card>

    <b-card
      v-if="!isMobile "
      class="devicesSideBar d-md-block"
      style="padding: 0 !important;overflow-x: hidden;"
    >
      <v-row style="background: #fff;">
        <v-col
          cols="8"
          md="8"
        >
          <v-text-field
            v-model="listQuery"
            color="#666"
            label="جستجوی نام، شناسه یا سیم‌کارت"
            class="searchDeviceInput"
            prepend-inner-icon="mdi-magnify"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
          md="4"
          style="padding-right: 0;"
        >
          <v-btn
            color="primary"
            class="searchButton btn-primary"
            style="min-width: 110px; position: absolute;top: 30px;color: #666;"
            @click="pageDeviceTable = 1"
          >
            جستجو
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        style="margin-top: 10px; margin-bottom: 2px;"
      >
        <v-col
          cols="12"
          md="12"
          style="padding-top: 0; padding-bottom: 0;"
        >
          <b-button
            v-if="mobileUser !== '09120000000'"
            variant="gradient-light"
            class="btn btn-primary btn-block"
            @click="onAddDeviceClick()"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            /> ثبت دستگاه جدید
          </b-button>
        </v-col>
      </v-row>
      <div class="dd-chips">
        <button
          v-for="c in statusChips"
          :key="c.value"
          class="dd-chip"
          :class="{ 'dd-chip-on': statusFilter === c.value }"
          @click="statusFilter = c.value"
        >
          <span
            v-if="c.color"
            class="dd-chipdot"
            :style="{ background: c.color }"
          />{{ c.label }}
        </button>
      </div>
      <b-card-text>
        <div class="dd-list">
          <!-- اسکلتونِ لودینگ هنگام بارگذاری اولیه -->
          <div
            v-if="listLoading"
            class="dd-skel-wrap"
          >
            <div class="dd-loading-head">
              <v-progress-circular
                indeterminate
                size="18"
                width="2"
                color="#7367f0"
              />
              <span>در حال دریافت خودروها… لطفاً کمی شکیبا باشید</span>
            </div>
            <div
              v-for="n in itemsPerPage"
              :key="'sk' + n"
              class="dd-skel"
            >
              <div class="dd-skel-ava" />
              <div class="dd-skel-lines">
                <div class="dd-skel-bar" style="width:55%" />
                <div class="dd-skel-bar" style="width:80%;height:18px" />
                <div class="dd-skel-bar" style="width:40%" />
              </div>
            </div>
          </div>

          <template v-else-if="pagedDevices.length">
            <device-row
              v-for="item in pagedDevices"
              :key="item.imei"
              :device="item"
              :menu-items="items"
              @select="sideDeviceClick"
              @action="onMenuAction"
              @renew="accountRenew"
            />
          </template>

          <div
            v-else
            class="dd-empty"
          >
            <v-icon
              size="42"
              color="#c4c8d4"
            >
              {{ (desserts && desserts.length) ? 'mdi-magnify-close' : 'mdi-car-off' }}
            </v-icon>
            <p class="dd-empty-txt">
              {{ (desserts && desserts.length) ? 'موردی با این جستجو/فیلتر پیدا نشد' : 'خودرویی برای نمایش نیست' }}
            </p>
          </div>
        </div>

        <div
          v-if="!listLoading && pageCountDeviceTable > 1"
          class="dd-pager"
        >
          <button
            class="dd-pbtn dd-pbtn-wide"
            :disabled="pageDeviceTable <= 1"
            @click="goPage(pageDeviceTable - 1)"
          >
            قبلی
          </button>
          <template v-for="(p, i) in pagerItems">
            <span
              v-if="p === '...'"
              :key="'e' + i"
              class="dd-pellipsis"
            >…</span>
            <button
              v-else
              :key="'p' + p"
              class="dd-pbtn"
              :class="{ 'dd-pbtn-on': p === pageDeviceTable }"
              @click="goPage(p)"
            >
              {{ faDigits(p) }}
            </button>
          </template>
          <button
            class="dd-pbtn dd-pbtn-wide"
            :disabled="pageDeviceTable >= pageCountDeviceTable"
            @click="goPage(pageDeviceTable + 1)"
          >
            بعدی
          </button>
        </div>
      </b-card-text>
    </b-card>
    <div
      v-if="playBackVisible"
      class="mobileOnMapHint mobileOnMapHintHistoryTime"
      style="direction: ltr;"
    >
      {{ timeHistory(dateHistory) }}
    </div>
    <div
      v-if="playBackVisible"
      class="mobileOnMapHint mobileOnMapHintHistorySpeed"
      style="direction: rtl;"
    >
      {{ speedHistory }} کیلومتر بر ساعت
    </div>
    <b-card
      v-if="playBackVisible"
      title=""
      class="playBack"
    >
      <div style="display: flex; padding: 10px 5px; direction: ltr;">
        <div
          v-if="!PlayStatus"
          class="playBtn"
          @click="onClickStartPlay()"
        >
          <v-icon
            color="rgb(28, 125, 230)"
            size="28"
          >
            mdi-play-circle</v-icon>
        </div>
        <div
          v-else
          class="playBtn"
          @click="onClickPausePlay()"
        >
          <v-icon
            color="rgb(230, 28, 28)"
            size="28"
          >
            mdi-pause-circle
          </v-icon>
        </div>
        <div style="width:100%; margin: auto;">
          <b-progress
            ref="listenTo"
            :value="playBackValue"
            max="100"
            height="10px"
            style="cursor: pointer; padding-top: 3px; padding-bottom: 3px;"
            @click.native="getClickPosition($event)"
          />
        </div>
        <div
          class="playBtn"
          style="right: 5px;"
          @click="onClickStopPlay()"
        >
          <v-icon
            color="rgb(230, 28, 28)"
            size="28"
          >
            mdi-stop-circle
          </v-icon>
        </div>
      </div>
      <!-- کنترل سرعت پخش به عنوان دکمه‌های انتخابی -->
      <div style="display: flex; justify-content: center; padding-top: 10px;">
        <b-button-group>
          <b-button
            v-for="play_speed in [1, 2, 4, 8]"
            :key="play_speed"
            :variant="playbackSpeed === play_speed ? 'primary' : 'outline-primary'"
            @click="playbackSpeed = play_speed"
          >
            {{ play_speed }}x
          </b-button>
        </b-button-group>
      </div>
    </b-card>
    <b-card
      v-show="historySideBarVisible && !playBackVisible"
      class="historySideBar"
    >
      <b-button
        append-to="body"
        class="btn btn-danger btn-circle closeBtn"
        @click="onClickCloseWayPointsSideBar()"
      >
        <feather-icon
          icon="XIcon"
          size="16"
        />
      </b-button>
      <div class="historySideBarBody">
        <div class="justify-content-center">
          <div
            class="col-10 col-md-12 "
            style="display: flex;padding-top: 0px;padding-bottom: 0px;margin: auto;"
          >
            <div
              class="historySideBar-btn"
              @click="NextDay"
            >
              <v-icon size="20">
                mdi-chevron-right
              </v-icon>
            </div>
            <date-picker
              v-model="mapHistoryDateFromFormatted"
              style="margin: 0 5px;"
              append-to="body"
            />
            <div
              class="historySideBar-btn"
              @click="PreviousDay"
            >
              <v-icon size="20">
                mdi-chevron-left
              </v-icon>
            </div>
          </div>
        </div>
        <div
          class="row"
          style="margin-top: 0;padding-left: 0;"
        >
          <div
            class="col-4 col-md-6"
            style="display: flex;"
          >
            <label style="padding: 8px;">از: </label>
            <date-picker
              v-model="mapHistoryTimeStart"
              type="time"
              append-to="body"
            />
          </div>
          <div
            class="col-4 col-md-6"
            style="display: flex;padding-right: 0;"
          >
            <label style="padding: 8px;">تا: </label>
            <date-picker
              v-model="mapHistoryTimeEnd"
              type="time"
              append-to="body"
            />
          </div>
          <div
            class="col-4 col-md-12"
            style="display: flex;"
          >
            <b-button
              class="btn btn-info btn-sm"
              style="width: 100%"
              @click="mapWayPointsAction()"
            >
              نمایش
            </b-button>
          </div>
        </div>
      </div>
    </b-card>

    <div dir="ltr">
      <l-map
        id="mainMap"
        ref="map"
        dir="ltr"
        :zoom="zoom"
        :min-zoom="5"
        :center="center"
        :max-bounds="iranBounds"
        :max-bounds-viscosity="1.0"
        :options="{zoomControl: true}"
      >
        <l-control-layers position="topleft" />
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :attribution="tileProvider.attribution"
          :subdomains="tileProvider.subdomains"
          layer-type="base"
          :options="{ maxZoom: 22 }"
        />
        <v-rotated-marker
          v-for="(marker, imei) in mapMarkers"
          :key="imei"
          ref="marker"
          :visible="marker.visible"
          :lat-lng="marker.latlng"
          :rotation-angle="marker.rotationAngle"
          :icon="marker.state === 'myLocation' ? myLocationIcon: marker.state === 'start' ? StartMoveIcon : marker.state === 'end' ? EndMoveIcon : marker.state === 'stop' ? StopMoveIcon : mapCarIcon[imei]"
          @click="onClickMarker(imei)"
        >
          <l-popup
            v-if="!isMobile"
            class="mapPopup"
          >
            <p> <span v-if="marker.state">

                  <strong>کاربر: </strong>{{ getPopupInfo(userImei).userId.name + ' ' + getPopupInfo(userImei).userId.family }}<br>
                  <strong>شناسه: </strong>{{ getPopupInfo(userImei).imei }}<br>
                  <strong style="display: inline-block;direction: rtl">عنوان : {{ getPopupInfo(userImei).title }}</strong><br>
                  <strong>سیمکارت: </strong>{{ getPopupInfo(userImei).sim }}<br>
                  <strong>وضعیت: </strong>{{ getDeviceStateLabel(getPopupInfo(userImei)) }}<br>
                  <strong>آخرین گزارش: </strong>{{ getLastContactLabel(getPopupInfo(userImei)) }}<br>
                  <bdi style="direction:rtl !important;display:inline-flex !important;gap:6px;align-items:center;margin-bottom:4px;unicode-bidi:isolate;" :title="getSatInfo(getPopupInfo(userImei)).title"><strong>کیفیت GPS: </strong><span :class="getSatInfo(getPopupInfo(userImei)).cls">{{ getSatInfo(getPopupInfo(userImei)).text }}</span></bdi><br>
                  <bdi style="direction:rtl !important;display:inline-flex !important;gap:6px;align-items:center;margin-bottom:4px;unicode-bidi:isolate;"><strong>باتری: </strong><span :class="getBatteryInfo(getPopupInfo(userImei)).cls">{{ getBatteryInfo(getPopupInfo(userImei)).text }}</span></bdi><br>
                  <strong>موقعیت مکانی توقف: </strong>{{ marker.latlng }}<br>
                  <strong style="display: inline-block;direction: rtl">وضعیت ماشین : {{ marker.state }}</strong><br>
                  <strong style="display: none">{{ getStopDuration(getPopupInfo(imei).imei, marker.latlng) }}</strong>
                  <span v-if="marker.state === 'stop'">
                    <strong>   شروع توقف: {{ formatTimestamp(getStopDuration(getPopupInfo(imei).imei, marker.latlng).start_time) }}
                    </strong><br>
                    <strong>پایان توقف: {{ formatTimestamp(getStopDuration(getPopupInfo(imei).imei, marker.latlng).end_time) }}
                    </strong><br>
                    <strong>مدت توقف:
                      {{ formatDuration(
                        getStopDuration(getPopupInfo(imei).imei, marker.latlng).start_time,
                        getStopDuration(getPopupInfo(imei).imei, marker.latlng).end_time
                      ) }}
                    </strong><br>
                  </span>

                </span>
              <span v-else>
                <strong>کاربر: </strong>{{ getPopupInfo(imei).userId.name + ' ' + getPopupInfo(imei).userId.family }}<br>
                <strong>شناسه: </strong>{{ getPopupInfo(imei).imei }}<br>
                <strong>عنوان: </strong>{{ getPopupInfo(imei).title }}<br>
                <strong>سیمکارت: </strong>{{ getPopupInfo(imei).sim }}<br>
                <strong>وضعیت: </strong>{{ getDeviceStateLabel(getPopupInfo(imei)) }}<br>
                <strong>آخرین گزارش: </strong>{{ getLastContactLabel(getPopupInfo(imei)) }}<br>
                <bdi style="direction:rtl !important;display:inline-flex !important;gap:6px;align-items:center;margin-bottom:4px;unicode-bidi:isolate;" :title="getSatInfo(getPopupInfo(imei)).title"><strong>کیفیت GPS: </strong><span :class="getSatInfo(getPopupInfo(imei)).cls">{{ getSatInfo(getPopupInfo(imei)).text }}</span></bdi><br>
                <bdi style="direction:rtl !important;display:inline-flex !important;gap:6px;align-items:center;margin-bottom:4px;unicode-bidi:isolate;"><strong>باتری: </strong><span :class="getBatteryInfo(getPopupInfo(imei)).cls">{{ getBatteryInfo(getPopupInfo(imei)).text }}</span></bdi><br>
              </span>

            </p>

            <div class="popup-actions">
              <b-link
                class="btn btn-secondary btn-sm"
                @click="onShowHistoryBar(imei)"
              >
                تاریخچه
              </b-link>
              <b-link
                class="btn btn-primary btn-sm"
                @click="onShowCommand(imei)"
              >
                تنظیمات
              </b-link>
              <b-link
                class="btn btn-icon btn-outline-info btn-sm"
                title="کپی مختصات"
                @click="copyDeviceCoords(imei)"
              >
                <feather-icon icon="CopyIcon" size="13" />
              </b-link>
              <b-link
                class="btn btn-icon btn-outline-success btn-sm"
                title="مشاهده در گوگل مپ"
                :href="getGoogleMapsUrl(imei)"
                target="_blank"
                rel="noopener"
              >
                <feather-icon icon="MapPinIcon" size="13" />
              </b-link>
            </div>
          </l-popup>
          <LTooltip
            :options="{
              interactive: false,
              permanent: true,
              opacity: 1,
              direction: 'top',
              offset: [0,-10]
            }"
          >
            <span
              v-if="getDeviceOnlineStatusCssClass(imei)!=='onlineSymbol'"
              style="color:gray;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
              v-else-if="getFixDeviceInfo(getPopupInfo(imei)).serverStatus.terminalInfo.gpsTracking"
              style="color:green;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
              v-else
              style="color:#e76c6c;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
          </LTooltip>

        </v-rotated-marker>
        <l-polyline
          :lat-lngs="polyline.latlngs"
          :color="polyline.color"
        />
      </l-map>

    </div>
    <b-modal
      ref="modal-change-sim"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="تغییر سیمکارت دستگاه"
    >
      <b-form>
        <b-form-group
          label="شماره سیمکارت فعلی"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="device.sim"
            class="numeric-input"
            maxlength="11"
            disabled
          />
        </b-form-group>
        <b-form-group
          label="شماره سیمکارت جدید"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="simIdSelected"
            placeholder="09xxxxxxxxx"
            maxlength="11"
            class="numeric-input"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-change-sim')"
        >
          بستن
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalChangeSim()"
        >
          ذخیره
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-change-name"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="تغییر نام خودرو"
    >
      <b-form>
        <b-form-group
          label="نام فعلی"
          label-for="v-title"
        >
          <b-form-input
            id="v-title"
            v-model="device.title"
            disabled
          />
        </b-form-group>
        <b-form-group
          label="نام جدید"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="newtitle"
            maxlength="100"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-change-name')"
        >
          بستن
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalChangeTitle()"
        >
          ذخیره
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-change-category"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="تغییر نوع خودرو"
    >
      <b-form>
        <b-form-group
          label="نوع وسیله نقلیه"
          label-for="v-address"
        >

          <b-form-select
            v-model="device.category"
            :select-size="6"
          >
            <b-form-select-option
              v-for="option in options"
              :key="option.value"
              :value="option.value"
            >
              <div>
                <v-icon
                  size="30"
                  color="#777"
                > {{ option.icon }}</v-icon>
                {{ option.text }}
              </div>
            </b-form-select-option>
          </b-form-select>

        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-change-category')"
        >
          بستن
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalChangeCategory()"
        >
          ذخیره
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-send-sms"
      cancel-variant="outline-secondary"
      ok-title="ذخیره"
      cancel-title="بستن"
      centered
      title="ارسال تنظیمات سرور"
    >
      <p>برای تنظیم ردیاب خود، دستور زیر را به سیمکارت با شماره
        {{ device.sim }}
        پیامک کنید</p>
      <code>{{ smsconfigtext }}</code>
      <br>
      <br>
      <b-button
        size="sm"
        variant="success"
        @click="modalSendSms()"
      >
        ارسال پیامک
      </b-button>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-send-sms')"
        >
          بستن
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-Command"
      ref="modal-Command"
      cancel-variant="outline-secondary"
      ok-title="افزودن"
      cancel-title="بستن"
      centered
      title="تنظیمات"
      size="lg"
      hide-footer
    >
      <div
        class="d-md-block"
        style="overflow-x: hidden;margin: 8px;overflow-y: scroll;height: 70vh;display: block;"
      >
        <app-CommandForm />
      </div>
    </b-modal>

    <AlertPopup
        v-if="showNotificationPopup"
        :imei="selectedDevice"
        @close="showNotificationPopup = false"
    />

  </div>

</template>

<script>
import DeviceRow from '@/views/Home/components/DeviceRow.vue'
import { deviceDisplay } from '@/utils/deviceDisplay'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import AlertPopup from '@/views/AlertPopup.vue'

import {
  BCard, BCardBody, BCardText, BLink, BButton, BFormInput, BButtonGroup, BFormGroup, BFormSelect, BFormSelectOption,
  BProgress, BProgressBar, BForm, BFormTextarea,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LControlZoom, LPolyline, LPopup, LControlLayers, LTooltip,
} from 'vue2-leaflet'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
import 'leaflet-routing-machine'
import 'leaflet/dist/leaflet.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Vue from 'vue'
import deviceService, { DeviceService } from '@/services/device.service'
import router from '@/router'
import Device from '@/models/device'
import { getUserData } from '@/auth/utils'
import UserService from '@/services/user.service'
import axios from 'axios'
import authHeader from '@/services/auth-header'
import { functions } from '@/functions'
import jalalimoment from 'jalali-moment'
import Config from '../../../config'
import AppCommandForm from './CammandForm.vue'
// eslint-disable-next-line import/no-extraneous-dependencies

const LeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [30, 18],
    shadowAnchor: [2, 42],
    popupAnchor: [-3, -20],
    iconSize: [60, 36],
  },
})
const myLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [18, 18],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [36, 36],
  },
})
const PinLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [23, 70],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [46, 75],
  },
})

export default {
  components: {
    DeviceRow,
    AppCommandForm,
    BFormTextarea,
    BProgress,
    AlertPopup,
    BProgressBar,
    BCard,
    BCardBody,
    BCardText,
    BLink,
    BButton,
    BButtonGroup,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    LMap,
    LTooltip,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup,
    LControlZoom,
    LControlLayers,
    datePicker: VuePersianDatetimePicker,
    AppCollapse,
    AppCollapseItem,
    BForm,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
  },
  data() {
    return {
      showNotificationPopup: true,
      userImei: localStorage.getItem('user_imei') || 'مقداری یافت نشد',
      LoadingText: 'درحال دریافت اطلاعات هستیم ...',
      stopDurations: [],
      playbackSpeed: 1, // مقدار اولیه سرعت پخش

      reportLog: '',
      mobileUser: getUserData().mobile,
      deviceInfobottom: '-129px',
      deviceInfoBox: true,
      deviceTracking: false,
      listDevice: false,
      usertype: getUserData().type,
      desktopSelectedDevices: {},
      search: '',
      timerCount: 10,
      desserts: [],
      pageDeviceTable: 1,
      itemsPerPage: 4,
      listQuery: '',
      statusFilter: '',
      listLoading: true,
      statusChips: [
        { value: '', label: 'همه', color: '' },
        { value: 'move', label: 'در حرکت', color: '#28c76f' },
        { value: 'park', label: 'پارک', color: '#ff9f43' },
        { value: 'off', label: 'آفلاین', color: '#a8b1bd' },
        { value: 'exp', label: 'منقضی', color: '#ea5455' },
      ],
      singleSelect: false,
      lastAngle: 0,
      dateHistory: '',
      speedHistory: 0,
      playBackVisible: false,
      PlayStatus: false,
      playTimerPointer: 0,
      playBackValue: 0,
      options: Config.carTypes,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      timer: null,
      speed: 0,
      address: null,
      mapTileLayer: {
        name: 'Map.ir XYZ',
        url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
        attribution: '© Map.ir & OSM',
      },
      tileProviders: [
        {
          name: 'Map.ir',
          visible: true,
          attribution: '© Map.ir',
          url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
        },
        {
          name: 'OpenStreet',
          visible: false,
          attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
      zoom: 5,
      // Iran position
      center: [32.4207, 53.6830],
      iranBounds: [[24.5, 44.0], [40.0, 63.5]],
      mapMarkers: {},
      devicesOnlineStatus: {},
      searchQuery: '',
      selectedImei: null,
      firstLoaded: true,
      historySideBarVisible: false,
      mapHistoryDateFromFormatted: '',
      mapHistoryTimeStart: '00:00',
      mapHistoryTimeEnd: '23:59',
      mapHistoryTimesSelected: {},
      isMobile: Vue.prototype.$functions.isMobile(),
      mobileSelectedDevices: this.$mobileSelectedDevices,
      polyline: {
        latlngs: [],
        color: 'red',
      },
      mapCarIcon: new LeafIcon({
        iconUrl: require('@/assets/images/pins/cars/car.png'),
      }),
      myLocationIcon: new myLeafIcon({
        iconUrl: require('@/assets/images/pins/myloc.png'),
      }),
      StartMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/startmarker-min.png'),
      }),
      EndMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/endmarker-min.png'),
      }),
      StopMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/stopmarker-min.png'),
      }),
      selectedDevice: null,
      simIdSelected: '',
      newtitle: '',
      smsconfigtext: 'SERVER,0,s1.4-rah.com,4000,0#',
      items: [
        { title: 'درخواست موقعیت لحظه‌ای', icon: 'mdi-crosshairs-gps', action: 'refresh' },
        { title: 'جزییات', icon: 'mdi-file-document-outline', action: 'detail' },
        { title: 'دستورات', icon: 'mdi-cog', action: 'command' },
        { title: 'سابقه حرکت', icon: 'mdi-map-marker-path', action: 'history' },
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  computed: {
    totalRecords() {
      return this.filteredDevices.length
    },
    // فیلترِ ریل‌تایم: جستجوی نام/شناسه/سیم‌کارت + فیلترِ وضعیت
    filteredDevices() {
      const toLatin = s => String(s || '').replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
      const q = toLatin(this.listQuery).trim().toLowerCase()
      const status = this.statusFilter
      return (this.desserts || []).filter(item => {
        if (q) {
          const title = String(item.title || '').toLowerCase()
          const imei = toLatin(item.imei).toLowerCase()
          const sim = toLatin(item.sim).toLowerCase()
          if (!title.includes(q) && !imei.includes(q) && !sim.includes(q)) return false
        }
        if (status) {
          const kind = deviceDisplay(item).kind
          if (status === 'move' && !(kind === 'move' || kind === 'tow')) return false
          if (status === 'park' && !(kind === 'park' || kind === 'idle')) return false
          if (status === 'off' && kind !== 'off') return false
          if (status === 'exp' && kind !== 'exp') return false
        }
        return true
      })
    },
    pageCountDeviceTable() {
      return Math.max(1, Math.ceil(this.totalRecords / this.itemsPerPage))
    },
    pagedDevices() {
      const per = this.itemsPerPage
      const start = (this.pageDeviceTable - 1) * per
      return this.filteredDevices.slice(start, start + per)
    },
    // صفحه‌بندی: همیشه صفحهٔ اول، سه صفحهٔ وسط (حولِ فعلی)، و همیشه صفحهٔ آخر
    pagerItems() {
      const total = this.pageCountDeviceTable
      const cur = this.pageDeviceTable
      if (total <= 5) {
        const all = []
        for (let i = 1; i <= total; i += 1) all.push(i)
        return all
      }
      const win = 3
      let start = Math.max(2, cur - 1)
      let end = Math.min(total - 1, start + win - 1)
      start = Math.max(2, end - win + 1)
      const items = [1]
      if (start > 2) items.push('...')
      for (let i = start; i <= end; i += 1) items.push(i)
      if (end < total - 1) items.push('...')
      items.push(total)
      return items
    },
    simpleTooltip() {
      // eslint-disable-next-line quotes
      return `Simple tooltip from property`
    },
    headers() {
      return [
        {
          text: 'دسته',
          align: 'start',
          sortable: false,
          value: 'category',
          width: '45px',
        },
        {
          text: 'عنوان',
          align: 'start',
          value: 'title',
          width: '50%',
        },
        {
          text: 'وضعیت ارتباط',
          align: 'start',
          value: 'onlineStatus',
        },
        {
          text: 'وضعیت حرکت',
          align: 'start',
          value: 'serverStatus',
        },
        {
          text: 'وضعیت ماهواره',
          align: 'start',
          value: 'serverInfo',
        },
        {
          text: 'گزینه ها',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    resultQuery() {
      return Vue.prototype.$functions.searchInDevices(this.searchQuery)
    },
  },
  watch: {
    // به‌محضِ آمدنِ دادهٔ دستگاه‌ها، اسکلتون برداشته شود (تا «خالی» فلش نکند)
    desserts(val) {
      if (val && val.length) this.listLoading = false
    },
    // با تغییرِ جستجو یا فیلترِ وضعیت، به صفحهٔ اول برگرد
    listQuery() {
      this.pageDeviceTable = 1
    },
    statusFilter() {
      this.pageDeviceTable = 1
    },
    timerCount: {
      handler(value) {
        if (value >= 0) {
          setTimeout(() => {
            // eslint-disable-next-line no-plusplus
            this.timerCount--
          }, 1000)
        } else {
          this.timerCount = 10
          this.$forceUpdate()
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },

  },
  created() {
    this.QXUpdateFirebaseData()
    this.$vuetify.rtl = true
    /*
    this.desktopSelectedDevices = localStorage.getItem('desktopSelectedDevices')
    if (this.desktopSelectedDevices !== null) {
      this.desktopSelectedDevices = JSON.parse(this.desktopSelectedDevices)
      Object.entries(this.desktopSelectedDevices).slice(50).map(entry => entry[1])
    }
    */

    this.showMarkers()
    this.checkOnlineStatus()
    this.doAction()
  },
  mounted() {
    // محدود کردن نقشه به ایران
    const applyIranBounds = () => {
      if (this.$refs.map && this.$refs.map.mapObject) {
        const map = this.$refs.map.mapObject
        map.setMaxBounds(L.latLngBounds([24.5, 44.0], [40.0, 63.5]))
        map.setMinZoom(5)
        map.options.maxBoundsViscosity = 1.0
        console.log('Iran bounds applied successfully')
      } else {
        setTimeout(applyIranBounds, 500)
      }
    }
    setTimeout(applyIranBounds, 1000)
    // اگر داده از قبل آماده بود، فوری نشان بده
    if (this.desserts && this.desserts.length) this.listLoading = false
    // ایمنی: اگر هیچ دستگاهی نبود، اسکلتون تا نهایتاً ۱۵ ثانیه بماند و بعد حالتِ خالی نشان داده شود.
    // (در حالتِ عادی واچِ desserts به‌محضِ آمدنِ داده اسکلتون را برمی‌دارد و «خالی» فلش نمی‌شود.)
    setTimeout(() => { this.listLoading = false }, 15000)
  //  setTimeout(() => { this.$forceUpdate() }, 3000)
  //  setTimeout(() => { this.$forceUpdate() }, 6000)
    /*
    this.$root.$on('forceUpdate', payload => {
      if (payload.event === 'socket.devicePosition') {
        if ('imei' in payload.data) {
          // برای غیر موبایل همیشه true هست و برای حالت موبایل
          // بررسی می شود که در صورت وجود در لیست نمایش دهد
          if (Vue.prototype.$functions.checkImeiInSelectedList(payload.data.imei)) {
            this.addUpdateMarker(payload.data)
            this.$forceUpdate()
          }

        }
      }
    })
    */
  },
  methods: {
    // صفحه‌بندیِ لیست خودروها (به‌جای اسکرولِ داخلی)
    goPage(p) {
      if (p < 1 || p > this.pageCountDeviceTable) return
      this.pageDeviceTable = p
    },
    faDigits(n) {
      return String(n).replace(/[0-9]/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    },
    // دکمهٔ «بروزرسانی» هر ردیف → درخواست موقعیت لحظه‌ای
    rowRefresh(device) {
      deviceService.sendCommand({ imei: device.imei, commandName: 'updatePosition' }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام', text: 'درخواست بروزرسانی ارسال شد', icon: 'CheckIcon', variant: 'success',
          },
        })
      }).catch(() => {})
    },
    // منوی تنظیماتِ هر ردیف
    onMenuAction(payload) {
      const { action, device } = payload
      if (action === 'refresh') { this.rowRefresh(device); return }
      if (action === 'detail') { this.sideDeviceClick(device); return }
      if (action === 'command') { this.onShowCommand(device.imei); return }
      if (action === 'history') { this.onShowHistoryBar(device.imei); return }
      this.onEditItem(action, device)
    },
    // eslint-disable-next-line camelcase
    formatDuration(start_time, end_time) {
      // eslint-disable-next-line camelcase
      if (!start_time || !end_time) return 'نامشخص'

      // eslint-disable-next-line camelcase
      const totalSeconds = end_time - start_time // محاسبه اختلاف بر حسب ثانیه
      const hours = Math.floor(totalSeconds / 3600) // تبدیل به ساعت
      const minutes = Math.floor((totalSeconds % 3600) / 60) // محاسبه دقیقه
      const seconds = totalSeconds % 60 // محاسبه ثانیه

      return `${hours} ساعت ${minutes} دقیقه ${seconds} ثانیه`
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return 'نامشخص'

      const date = new Date(timestamp * 1000) // تبدیل ثانیه به میلی‌ثانیه
      return date.toLocaleString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },

    processStopDurations(data) {
      const stops = []
      let startTime = null

      data.forEach(record => {
        if (record.speed === 0) {
          if (startTime === null) {
            startTime = record.devicetime
          }
        } else if (startTime !== null) {
          stops.push({
            start_time: startTime,
            end_time: record.devicetime,
            duration: (new Date(record.devicetime) - new Date(startTime)) / 1000, // مدت توقف به ثانیه
          })
          startTime = null
        }
      })

      // ذخیره توقف‌ها در localStorage
      localStorage.setItem('stopDurations', JSON.stringify(stops))

      this.stopDurations = stops
    },
    getStopDuration(imei, latlng) {
      // دریافت داده‌های توقف از localStorage
      const stopDurations = JSON.parse(localStorage.getItem('stopDurations')) || []

      if (!Array.isArray(stopDurations) || stopDurations.length === 0) {
        return 'بدون توقف'
      }

      // پیدا کردن توقفی که هم imei و هم مختصات latlng مطابق باشد
      const stopData = stopDurations.find(stop => stop.lat === latlng[0])

      if (!stopData) {
        return 'بدون توقف'
      }

      // محاسبه مدت توقف به ثانیه
      const totalSeconds = Math.floor(stopData.duration)
      let minutes = Math.floor(totalSeconds / 60)
      const hours = Math.floor(minutes / 60)
      const seconds = totalSeconds % 60
      minutes %= 60

      // نمایش زمان به فرمت مناسب (ساعت، دقیقه، ثانیه)
      if (hours > 0) {
        return `${hours} ساعت ${minutes} دقیقه ${seconds} ثانیه`
      } if (minutes > 0) {
        return `${minutes} دقیقه ${seconds} ثانیه`
      }
      return stopData
    },

    convertToEnglishNumbers(input) {
      const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
      const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

      let result = input
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < persianNumbers.length; i++) {
        result = result.replace(persianNumbers[i], englishNumbers[i])
      }
      return result
    },
    getDeviceIndex(imei) {
      for (let i = 0; i <= Vue.prototype.$devices.length - 1; i += 1) {
        if (Vue.prototype.$devices[i].imei === imei) {
          return i
        }
      }
      return null
    },
    onSearchClick() {
      if (!this.search || this.search.trim() === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'لطفاً مقدار جستجو را وارد کنید.',
            icon: 'AlertCircleIcon',
            variant: 'info',
          },
        })
        return // متوقف کردن اجرای ادامه متد
      }

      // تبدیل اعداد فارسی به انگلیسی
      this.search = this.convertToEnglishNumbers(this.search)

      // بررسی اینکه مقدار وارد شده فقط شامل عدد است
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(this.search) && this.search.length > 0 && this.usertype !== 2) {
        // بررسی فرمت IMEI (طول باید 15 باشد)
        if (this.search.length !== 15) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'خطا',
              text: 'IMEI وارد شده باید دقیقاً 15 رقم باشد.',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          return
        }
      }

      this.searchDevices(this.search)
    },
    async fetchDeviceList() {
      try {
        const response = await axios.post(
          'https://api.4-rah.com/user/device/list',
          {},
          { headers: authHeader() },
        )

        if (response.data?.result?.data?.length > 0) {
          Vue.prototype.$devices = response.data.result.data.map(device => {
            const fixedDevice = functions.fixDeviceInfo(device)
            fixedDevice.onlineStatus = 'offlineSymbol'
            return fixedDevice
          })
          this.desserts = Vue.prototype.$devices

          // دریافت موقعیت دستگاه‌ها برای به‌روزرسانی وضعیت
          const imeis = this.desserts.map(device => device.imei)
          const positionResponse = await deviceService.getPositions({
            imeis,
            fromDate: 0,
            toDate: 0,
            limit: 1,
            sortItems: [{ name: 'servertime', desc: true }],
          })

          if (positionResponse.status === 'success' && 'result' in positionResponse) {
            for (const imei in positionResponse.result) {
              if (positionResponse.result[imei].length > 0) {
                const deviceIndex = this.desserts.findIndex(device => device.imei === imei)
                const pos = positionResponse.result[imei][0]
                const lastStatus = pos.lastStatus || null

                if (deviceIndex !== -1) {
                  this.desserts[deviceIndex].serverStatus = lastStatus
                  const serverInfo = { ...pos }
                  delete serverInfo.lastStatus
                  this.desserts[deviceIndex].serverInfo = serverInfo
                }
              }
            }
            Vue.prototype.$socket.emit('devicesOnlineTime', {})
          }
        } else {
          Vue.prototype.$devices = []
          this.desserts = []
          this.LoadingText = 'هیچ اطلاعاتی یافت نشد'
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'پیام',
              text: 'هیچ نتیجه‌ای یافت نشد',
              icon: 'AlertCircleIcon',
              variant: 'info',
            },
          })
        }
      } catch (error) {
        // console.error('Error fetching devices:', error)
        const errorMessage = error.response?.data?.message || 'درخواست لیست به مشکل برخورد.'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: errorMessage,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally {
        // پایانِ بارگذاریِ اولیه؛ اسکلتون برداشته می‌شود
        this.listLoading = false
      }
    },

    async changeSearchDevices(searchQuery) {
      if (!searchQuery) {
        await this.fetchDeviceList()
      }
    },
    async searchDevices(searchQuery) {
      if (!searchQuery) {
        await this.fetchDeviceList()
        return
      }

      // چک کردن حداقل تعداد کاراکترهای ورودی
      if (!searchQuery || searchQuery.length < 3) {
        return
      }

      try {
        const response = await axios.post(
          `${Vue.prototype.$apiServers.url}/user/device/search`,
          { search: searchQuery },
          { headers: authHeader() },
        )

        if (response.data?.result?.data?.length > 0) {
          const today = jalalimoment().format('jYYYY/jMM/jDD')

          // بروز رسانی Vue.prototype.$devices و desserts
          Vue.prototype.$devices = response.data.result.data.map(device => {
            const fixedDevice = functions.fixDeviceInfo(device)
            fixedDevice.onlineStatus = 'offlineSymbol'

            if (device.expireTime) {
              const expireDate = jalalimoment(device.expireTime, 'jYYYY/jMM/jDD').format('jYYYY/jMM/jDD')
              fixedDevice.expire = expireDate < today
            } else {
              fixedDevice.expire = false
            }

            return fixedDevice
          })
          this.desserts = Vue.prototype.$devices

          // دریافت موقعیت دستگاه‌ها
          const imeis = this.desserts.map(device => device.imei)
          const positionResponse = await deviceService.getPositions({
            imeis,
            fromDate: 0,
            toDate: 0,
            limit: 1,
            sortItems: [{ name: 'servertime', desc: true }],
          })

          if (positionResponse.status === 'success' && 'result' in positionResponse) {
            // به‌روزرسانی موقعیت دستگاه‌ها
            for (const imei in positionResponse.result) {
              if (positionResponse.result[imei].length > 0) {
                const deviceIndex = this.desserts.findIndex(device => device.imei === imei)
                const pos = positionResponse.result[imei][0]
                const lastStatus = pos.lastStatus || null

                if (deviceIndex !== -1) {
                  this.desserts[deviceIndex].serverStatus = lastStatus
                  const serverInfo = { ...pos }
                  delete serverInfo.lastStatus
                  this.desserts[deviceIndex].serverInfo = serverInfo
                }
              }
            }
            Vue.prototype.$socket.emit('devicesOnlineTime', {})
          }
        } else {
          Vue.prototype.$devices = []
          this.LoadingText = 'هیچ اطلاعاتی یافت نشد'
          this.desserts = []
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'پیام',
              text: 'هیچ نتیجه‌ای یافت نشد',
              icon: 'AlertCircleIcon',
              variant: 'info',
            },
          })
        }
      } catch (error) {
        // console.error('Error fetching devices:', error)
        const errorMessage = error.response?.data?.message || 'درخواست جستجو به مشکل برخورد.'
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: errorMessage,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    },

    accountRenew(item) {
      this.$router.push({
        name: 'subscription-renew',
        query: { imei: item.imei }
      })
    },
    rowClick(item, row) {
      row.select(true)
      // item.name - selected id
    },
    /// ////////////////////////////////////////
    showMarkers() {
      // کاربر قبلا لاگین کرده و مستقیم وارد این صفحه می شود
      // در نتیجه لیست دستگاه ها باید گرفته شود
      Vue.prototype.$functions.fillDevices().then(() => {
        let lngh = 20
        if (Vue.prototype.$devices.length < 20) {
          lngh = Vue.prototype.$devices.length
        }
        for (let i = 0; i <= lngh - 1; i++) {
          const device = Vue.prototype.$devices[i]
          this.desktopSelectedDevices[device.imei] = true
          // console.log(device)
        }
        Vue.prototype.$functions.setImeiForSocket(this.desktopSelectedDevices)

        let setFirstDesktopSelectedDevices = false
        if (this.desktopSelectedDevices === null) {
          this.desktopSelectedDevices = {}
          setFirstDesktopSelectedDevices = true
        }

        for (let i = 0; i <= Vue.prototype.$devices.length - 1; i++) {
          Vue.prototype.$devices[i] = this.getFixDeviceInfo(Vue.prototype.$devices[i])
          const device = Vue.prototype.$devices[i]
          if (setFirstDesktopSelectedDevices) {
            this.desktopSelectedDevices[device.imei] = true
          } else if (!(device.imei in this.desktopSelectedDevices)) {
            this.desktopSelectedDevices[device.imei] = false
          }

          if (typeof device.serverInfo === 'undefined') {
            // eslint-disable-next-line no-continue
            device.serverInfo = {}
          }

          // استفاده از helper برای استخراج امن مختصات
          const coords = Vue.prototype.$functions.getLatLngFromServerInfo(device.serverInfo)
          if (!coords) {
            // eslint-disable-next-line no-continue
            continue
          }

          const data = {
            latitude: coords.lat,
            longitude: coords.lng,
            imei: device.imei,
          }
          const deviceInfo = Vue.prototype.$functions.getDeviceInfo(data.imei)
          if (typeof this.options[deviceInfo.category] === 'undefined') {
            deviceInfo.category = 0
          }
          // eslint-disable-next-line new-cap
          this.mapCarIcon[device.imei] = new LeafIcon({
            // eslint-disable-next-line global-require,import/no-dynamic-require
            iconUrl: require(`@/assets/images/pins/cars/${this.options[deviceInfo.category].src}.png`),
          })
          // if(this.desktopSelectedDevices[device.imei]){
          this.addUpdateMarker(data)
          // }
          // this.addUpdateMarker(data)
          /*
          if (Vue.prototype.$functions.checkImeiInSelectedList(data.imei)) {
            this.addUpdateMarker(data)
            // در حالت موبایل چون یک دستگاه نمایش داده می شود
            // روی آن زوم می شود
            if (Vue.prototype.$functions.isMobile()) {
              this.setMapCenterAndZoom([data.latitude, data.longitude], 10)
            }
          }
           */
        }

        localStorage.setItem('desktopSelectedDevices', JSON.stringify(this.desktopSelectedDevices))
        // اگر موبایل نبود جدول لیست پر شود
        if (!this.isMobile) {
          this.desserts = Vue.prototype.$devices
        }
        this.checkSelectedDevices()
      })
    },
    addMarker(imei) {
      const index = Vue.prototype.$functions.getDeviceIndex(imei)
      if (index === -1) return
      const deviceInfo = Vue.prototype.$devices[index]
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return

      const data = {
        latitude: coords.lat,
        longitude: coords.lng,
        imei,
      }
      this.mapMarkers[data.imei] = {
        // علاوه بر اینکه باید برای نمایش انتخاب شده باشد اگر
        // مقادیر مختصاتی نا معتبر داشته باشد هم نباید نمایش داده شود زیرا
        // نقطه نمایش پرت خواهد بود و نامرتبط
        visible: true,
        latlng: [coords.lat, coords.lng],
        rotationAngle: this.lastAngle,
      }
      this.desktopSelectedDevices[data.imei] = true
      Vue.prototype.$functions.setImeiForSocket(this.desktopSelectedDevices)
      this.addUpdateMarker(data)
    },
    onClickMarker(imei) {
      // console.log(imei)
      this.selectedDevice = imei
      this.desktopSelectedDevices[imei] = true

      this.addMarker(imei)
      Vue.prototype.$functions.setMobileSelectedDevices([this.selectedDevice])
      // رفرش فوری وضعیت دستگاه انتخاب‌شده تا popup همیشه تازه باز شود
      this.refreshSinglePosition(imei)
      const deviceInfo = this.getPopupInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.setMapCenterAndZoom([coords.lat, coords.lng], 17)
      this.$forceUpdate()
    },

    async sideDeviceClick(row) {
      this.desktopSelectedDevices[row.imei] = true
      //  console.log(JSON.stringify(row))
      this.selectedDevice = row.imei
      await this.addMarker(row.imei)
      const index2 = Vue.prototype.$functions.getDeviceIndex(row.imei)

      // console.log(this.mapMarkers[row.imei])
      // console.log(Vue.prototype.$devices[index2])
      if (this.mapMarkers[row.imei] === undefined || this.mapMarkers[row.imei].latlng.length <= 0 || (this.mapMarkers[row.imei].latlng[0] === 0
          && this.mapMarkers[row.imei].latlng[1] === 0) || this.mapMarkers[row.imei].latlng[0] === undefined) {
        this.setMapCenterAndZoom([this.center[0], this.center[1]], 5)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'هنوز اطلاعات مکانی از طرف دستگاه ارسال نشده است.',
            icon: 'XIcon',
            variant: 'danger',
          },
        })

        return
      }
      this.$forceUpdate()
      const index = await Vue.prototype.$functions.getDeviceIndex2(this.mapMarkers, row.imei)

      // console.log(index)
      // Safe check before accessing mapObject
      if (this.$refs.marker && this.$refs.marker[parseInt(index)] && this.$refs.marker[parseInt(index)].mapObject) {
        this.$refs.marker[parseInt(index)].mapObject.openPopup()
      }

      this.setMapCenterAndZoom([this.mapMarkers[row.imei].latlng[0],
        this.mapMarkers[row.imei].latlng[1]], 16)
    },

    desktopDataTableInput(list) {
      this.desktopSelectedDevices = {}
      for (let i = 0; i <= Vue.prototype.$devices.length - 1; i++) {
        const { imei } = Vue.prototype.$devices[i]
        if (list.find(element => element.imei === imei)) {
          this.desktopSelectedDevices[imei] = true
        } else {
          this.desktopSelectedDevices[imei] = false
        }
        if ('serverInfo' in Vue.prototype.$devices[i] && 'lat' in Vue.prototype.$devices[i].serverInfo) {
          this.mapMarkers[imei].visible = this.isVisibleMarker(imei, Vue.prototype.$devices[i].serverInfo.lat, Vue.prototype.$devices[i].lon)
        } else {
          this.mapMarkers[imei].visible = false
        }
      }
      localStorage.setItem('desktopSelectedDevices', JSON.stringify(this.desktopSelectedDevices))
      Vue.prototype.$functions.setImeiForSocket(this.desktopSelectedDevices)
      // this.$forceUpdate()
    },
    /// //////////////////////////////////////////////////////////
    onShowCommand(imei) {
      Vue.prototype.$selectCommand = imei
      this.$refs['modal-Command'].show()
    },
    hideModalCommand() {
      this.$refs['modal-Command'].hide()
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    clickAlarm() {
      this.$emit('on-change-page', 'alertList', this.selectedDevice)
    },
    downdeviceInfo() {
      this.deviceInfobottom = '-129px'
    },
    updeviceInfo() {
      this.deviceInfobottom = 0
    },
    monitoring() {
      router.push({ name: 'home' }).catch(err => {})
    },
    filterPerfectMatch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search))
    },
    buildLogoUrl(category) {
      try {
        return this.options[category].icon
      } catch (e) {
        return 'mdi-car-hatchback'
      }
      /*
      try {
        return require(`@/assets/images/pins/cars/${this.options[category].src}.png`)
      } catch (e) {
        return require('@/assets/images/pins/cars/car.png')
      } */
    },
    doFillDevices() {
      this.showMarkers()
    },
    checkSelectedDevices() {
      if (Vue.prototype.$mobileSelectedDevices.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.selectedDevice = Vue.prototype.$mobileSelectedDevices[0]
      }
    },
    getClickPosition(event) {
      const e = event || window.e

      // get target element
      let target = e.target || e.srcElement
      // fix for a safari bug
      if (target.nodeType === 3) target = target.parentNode
      // set initial wrapper width
      this.wrapperWidth = this.wrapperWidth || target.offsetWidth

      // get the seek width
      const seekWidth = e.offsetX

      // change seek position
      this.playBackValue = (seekWidth / this.wrapperWidth) * 100
      this.onClickPausePlay()
      // eslint-disable-next-line radix
      this.StartPlay(parseInt((this.playBackValue * this.polyline.latlngs.length) / 100))
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    getDeviceOnlineStatusCssClass(imei) {
      try {
        return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
      } catch (e) {
        return false
      }
    },
    calcAngle(cx, cy, ex, ey) {
      const dy = ey - cy
      const dx = ex - cx
      // range (-PI, PI]
      let theta = Math.atan2(dy, dx)
      // rads to degs, range (-180, 180]
      theta *= 180 / Math.PI
      // if (theta < 0) theta = 360 + theta; // range [0, 360)
      return theta
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
    openDashboard(row) {
      Vue.prototype.$functions.setMobileSelectedDevices([row.imei])
      router.push({ name: 'device-dashboard' })
    },
    getMyLocation() {
      // additionally, supplying options for fine-tuning, if you want to
      const options = {
        enableHighAccuracy: true,
        // time in millis when error callback will be invoked
        timeout: 5000,
        // max cached age of gps data, also in millis
        maximumAge: 0,
      }
      return new Promise(((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          pos => { resolve(pos) },
          err => { reject(err) },
          options,
        )
      }))
    },
    timeHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      return this.$functions.unixToPersianDate(unixTime)
    },
    sinceFrom(unixTime) {
      // اگر مقدار undefined یا null بود، مقدار پیش‌فرض 0 را بده
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }

      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    getDeviceStateLabel(deviceInfo) {
      if (!deviceInfo || !deviceInfo.serverInfo) return this.$t('Unknown')
      const servertime = deviceInfo.serverInfo.servertime
      if (!servertime || servertime < 1000) return this.$t('Unknown')

      const speed = deviceInfo.serverInfo.speed || 0
      const ignition = deviceInfo.serverStatus?.terminalInfo?.ignition || false
      const ignitionChangeTime = deviceInfo.serverStatus?.terminalInfo?.ignitionChangeTime || 0
      const now = Vue.prototype.$functions.time()

      if (ignition && speed > 2) return `در حال حرکت با سرعت ${speed} کیلومتر`
      if (ignition) return 'موتور روشن، متوقف'

      const parkedSince = (ignitionChangeTime > 1000000000) ? ignitionChangeTime : servertime
      const parkedMin = Math.round((now - parkedSince) / 60)
      return `پارک کرده، ${this.formatDurationFa(parkedMin)}`
    },
    getSatInfo(deviceInfo) {
      if (!deviceInfo || !deviceInfo.serverInfo) return { text: '—', cls: 'sat-info', title: '' }
      const active = deviceInfo.serverInfo.satCntActive
      const total = deviceInfo.serverInfo.satCnt
      if (active === undefined || active === null) return { text: '—', cls: 'sat-info', title: '' }
      let label, cls
      if (active < 4)      { label = 'موقعیت دقیق نیست'; cls = 'sat-info sat-bad' }
      else if (active < 6) { label = 'موقعیت تقریبی';  cls = 'sat-info sat-medium' }
      else if (active < 8) { label = 'موقعیت دقیق';    cls = 'sat-info sat-good' }
      else                 { label = 'موقعیت بسیار دقیق'; cls = 'sat-info sat-good' }
      const countStr = total ? `${active} از ${total}` : `${active}`
      const text = `${label} (${countStr} ماهواره)`
      const title = `${active}${total ? ' از ' + total : ''} ماهواره فعال`
      return { text, cls, title }
    },
    getBatteryInfo(deviceInfo) {
      if (!deviceInfo || !deviceInfo.serverStatus) return { text: '—', cls: 'bat-info' }
      const level = deviceInfo.serverStatus.voltageLevel
      const charging = deviceInfo.serverStatus.terminalInfo && deviceInfo.serverStatus.terminalInfo.charging
      if (!level) return { text: '—', cls: 'bat-info' }
      const map = {
        'no power (shutdown)':              { text: 'بدون برق', cls: 'bat-critical' },
        'very low battery (low battery alarm)': { text: 'بسیار ضعیف', cls: 'bat-critical' },
        'low battery':                      { text: 'ضعیف', cls: 'bat-low' },
        'medium':                           { text: 'متوسط', cls: 'bat-medium' },
        'high':                             { text: 'خوب', cls: 'bat-good' },
        'very high':                        { text: 'عالی', cls: 'bat-good' },
      }
      const m = map[level] || { text: level, cls: 'bat-medium' }
      const chargeIcon = charging ? ' ⚡' : ''
      return { text: m.text + chargeIcon, cls: 'bat-info ' + m.cls }
    },
    getDeviceLatLng(imei) {
      const d = this.getPopupInfo(imei)
      if (!d || !d.serverInfo) return null
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(d.serverInfo)
      if (!coords || !coords.lat || !coords.lng) return null
      return { lat: coords.lat, lng: coords.lng }
    },
    getGoogleMapsUrl(imei) {
      const c = this.getDeviceLatLng(imei)
      if (!c) return '#'
      return `http://maps.google.com/maps?q=N${c.lat.toFixed(6)},E${c.lng.toFixed(6)}`
    },
    copyDeviceCoords(imei) {
      const c = this.getDeviceLatLng(imei)
      if (!c) {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'خطا', text: 'مختصاتی برای این دستگاه ثبت نشده', icon: 'AlertCircleIcon', variant: 'warning' },
        })
        return
      }
      const text = `${c.lat.toFixed(6)},${c.lng.toFixed(6)}`
      const onSuccess = () => {
        this.$toast({
          component: ToastificationContent,
          props: { title: 'کپی شد', text: `مختصات: ${text}`, icon: 'CheckIcon', variant: 'success' },
        })
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(() => {
          this.fallbackCopy(text, onSuccess)
        })
      } else {
        this.fallbackCopy(text, onSuccess)
      }
    },
    fallbackCopy(text, onSuccess) {
      try {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.style.position = 'fixed'
        ta.style.top = '-1000px'
        document.body.appendChild(ta)
        ta.select()
        document.execCommand('copy')
        document.body.removeChild(ta)
        onSuccess()
      } catch (e) { /* ignore */ }
    },
    getLastContactLabel(deviceInfo) {
      if (!deviceInfo || !deviceInfo.serverInfo) return this.$t('Unknown')
      const servertime = deviceInfo.serverInfo.servertime || 0
      const statusServertime = deviceInfo.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    formatDurationFa(minutes) {
      if (minutes < 60) return `${minutes} دقیقه`
      const h = Math.floor(minutes / 60)
      const m = minutes % 60
      if (h < 24) return m === 0 ? `${h} ساعت` : `${h} ساعت و ${m} دقیقه`
      const d = Math.floor(h / 24)
      const remH = h % 24
      return remH === 0 ? `${d} روز` : `${d} روز و ${remH} ساعت`
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      clearInterval(Vue.prototype.$positionRefreshTimer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
      // REST polling: مستقل از Socket.io، تضمین می‌کند داده‌ها حداکثر 30 ثانیه عقب می‌مانند
      Vue.prototype.$positionRefreshTimer = setInterval(() => {
        this.refreshAllPositions()
      }, 30000)
    },
    refreshAllPositions() {
      if (!Vue.prototype.$devices || Vue.prototype.$devices.length === 0) return
      const imeis = Vue.prototype.$devices.map(d => d.imei)
      deviceService.getPositions({
        imeis,
        fromDate: 0,
        toDate: 0,
        limit: 1,
        sortItems: [{ name: 'servertime', desc: true }],
      }).then(resp => {
        if (resp.status === 'success' && 'result' in resp) {
          for (const imei in resp.result) {
            if (resp.result[imei].length > 0) {
              const deviceIndex = Vue.prototype.$functions.getDeviceIndex(imei)
              if (deviceIndex === null || !Vue.prototype.$devices[deviceIndex]) continue
              if (resp.result[imei][0].lastStatus) {
                Vue.prototype.$devices[deviceIndex].serverStatus = resp.result[imei][0].lastStatus
              }
              delete resp.result[imei][0].lastStatus
              Vue.prototype.$devices[deviceIndex].serverInfo = resp.result[imei][0]
            }
          }
          this.$forceUpdate()
        }
      }).catch(() => { /* silent: socket events ادامه دارند */ })
    },
    refreshSinglePosition(imei) {
      if (!imei) return
      deviceService.getPositions({
        imeis: [imei],
        fromDate: 0,
        toDate: 0,
        limit: 1,
        sortItems: [{ name: 'servertime', desc: true }],
      }).then(resp => {
        if (resp.status === 'success' && resp.result && resp.result[imei] && resp.result[imei].length > 0) {
          const deviceIndex = Vue.prototype.$functions.getDeviceIndex(imei)
          if (deviceIndex === null || !Vue.prototype.$devices[deviceIndex]) return
          if (resp.result[imei][0].lastStatus) {
            Vue.prototype.$devices[deviceIndex].serverStatus = resp.result[imei][0].lastStatus
          }
          delete resp.result[imei][0].lastStatus
          Vue.prototype.$devices[deviceIndex].serverInfo = resp.result[imei][0]
          this.$forceUpdate()
        }
      }).catch(() => { /* silent */ })
    },
    doAction() {
      switch (this.$route.params.action) {
        case 'history':
          this.onMobileMapShowHistoryBar()
      }
    },
    onClickPausePlay() {
      this.PlayStatus = false
    },
    onClickStopPlay() {
      this.PlayStatus = false

      this.polyline.latlngs = []
      this.searchQuery = ''
      //  this.historySideBarVisible = false
      this.playBackVisible = false

      // TODO: نیاز به بررسی بیشتر دارد و صحیح نیست
      // اما برای رفع عیب موقت هنگام بسته شدن نوار
      // تاریخچه مناسب است
      this.mapMarkers = {}
      this.showMarkers()
    },
    onClickStartPlay() {
      this.PlayStatus = true
      let index = 0
      if (this.playBackValue !== 0) {
        index = parseInt((this.playBackValue * this.polyline.latlngs.length) / 100) + 2
      }
      this.StartPlay(index)
    },
    StartPlay(index) {
      if (typeof this.polyline.latlngs[index] === 'undefined') return
      this.dateHistory = this.polyline.devicetime[index]
      this.speedHistory = this.polyline.devicespeed[index]
      this.playBackValue = parseInt((100 * index) / this.polyline.latlngs.length)
      const data1 = {
        latitude: this.polyline.latlngs[index][0],
        longitude: this.polyline.latlngs[index][1],
        imei: this.selectedImei,
      }

      this.addUpdateMarker(data1)
      setTimeout(
        () => {
          if (this.PlayStatus) {
            this.StartPlay(index + 1)
          }
        },
        1000 / this.playbackSpeed,
      )
    },
    routing(payload) {
      this.mapMarkers = {} // نقشه‌برداری نقاط
      this.polyline.latlngs = [] // آرایه‌ای برای مختصات مسیر
      this.polyline.devicetime = [] // زمان‌ها
      this.polyline.devicespeed = [] // سرعت‌ها
      this.stopDurations = [] // آرایه‌ای برای ذخیره توقف‌ها

      let stopStart = null // شروع توقف

      deviceService.getPositions({
        imeis: payload.imeis,
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        limit: payload.limit,
        sortItems: payload.sortItems,
      }).then(resp => {
        if (resp.status === 'success' && 'result' in resp) {
          // پیمایش داده‌های دستگاه‌ها
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < payload.imeis.length; i++) {
            const imei = payload.imeis[i]
            const positions = resp.result[imei]

            // eslint-disable-next-line no-plusplus
            for (let j = 0; j < positions.length; j++) {
              const pos = positions[j]

              // بررسی وجود مختصات مکانی
              // eslint-disable-next-line no-continue
              if (!pos.latitude || !pos.longitude) continue

              // استخراج امن مختصات
              let lat, lng
              if (typeof pos.latitude === 'object' && pos.latitude.$numberDecimal) {
                lat = parseFloat(pos.latitude.$numberDecimal)
                lng = parseFloat(pos.longitude.$numberDecimal)
              } else {
                lat = parseFloat(pos.latitude)
                lng = parseFloat(pos.longitude)
              }
              if (Number.isNaN(lat) || Number.isNaN(lng)) continue
              const position = [lat, lng]

              // ذخیره مختصات مسیر
              this.polyline.latlngs.push(position)
              this.polyline.devicetime.push(pos.devicetime)
              this.polyline.devicespeed.push(pos.speed)

              // ثبت نقطه شروع
              if (j === 0) {
                this.dateHistory = pos.devicetime
                this.mapMarkers[Math.floor(Math.random() * 999999)] = {
                  state: 'start',
                  latlng: position,
                  rotationAngle: 0,
                }
                // eslint-disable-next-line brace-style
              }
              // ثبت نقطه پایان
              else if (j === positions.length - 1) {
                this.mapMarkers[Math.floor(Math.random() * 999999)] = {
                  state: 'end',
                  latlng: position,
                  rotationAngle: 0,
                }
              }

              // شناسایی توقف‌ها
              if (pos.speed === 0) {
                if (!stopStart) {
                  stopStart = pos.devicetime // زمان شروع توقف
                }
              } else {
                // اگر توقف قبلی به پایان رسیده باشد، توقف جدید را ثبت کن
                // eslint-disable-next-line no-lonely-if
                if (stopStart) {
                  const stopEnd = pos.devicetime
                  const stopDuration = (new Date(stopEnd) - new Date(stopStart)) / 1000 // مدت توقف بر حسب ثانیه
                  // console.log(`stopDuration${stopDuration}`)

                  if (stopDuration >= 2) { // اگر مدت توقف بیشتر از 60 ثانیه بود
                    // ذخیره مدت زمان توقف

                    const stopData = {
                      imei,
                      start_time: stopStart,
                      end_time: stopEnd,
                      latlng: position,
                      lat: position[0],
                      lng: position[1],
                      location_id: j,
                      duration: stopDuration,
                    }

                    this.stopDurations.push(stopData)
                    localStorage.setItem('stopDurations', JSON.stringify(this.stopDurations))
                    localStorage.setItem('user_imei', imei)

                    // اضافه کردن نقطه توقف به نقشه
                    this.mapMarkers[Math.floor(Math.random() * 999999)] = {
                      state: 'stop',
                      latlng: position,
                      rotationAngle: 0,
                    }
                  }

                  stopStart = null // ریست کردن زمان شروع توقف برای توقف بعدی
                }
              }
            }

            // بعد از اتمام تمام نقاط، نقشه را به سمت مسیر تنظیم می‌کنیم
            if (positions.length > 0 && this.$refs.map && this.$refs.map.mapObject && this.polyline.latlngs.length > 0) {
              this.$refs.map.mapObject.fitBounds(this.polyline.latlngs)
            }
          }
        }
      },
      error => {
        this.message = error.response?.data?.message || error.message || error.toString()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطا',
            text: this.message,
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      })
    },
    mapWayPointsAction() {
      if (this.mapHistoryDateFromFormatted === '') {
        alert('تاریخ شروع یا پایان معتبر نیست.')
        return
      }

      const payload = {
        imeis: [this.selectedImei],
        fromDate: jalalimoment(`${this.mapHistoryDateFromFormatted} ${this.mapHistoryTimeStart}`, 'jYYYY/jMM/jDD HH:mm').unix(),
        toDate: jalalimoment(`${this.mapHistoryDateFromFormatted} ${this.mapHistoryTimeEnd}`, 'jYYYY/jMM/jDD HH:mm').unix(),
        limit: 0,
        sortItems: [{ name: 'servertime', asc: true }],
      }

      this.playBackVisible = true
      this.routing(payload)
    },
    getUnixTimeStartEndFormat(arr) {
      arr.start = jalalimoment(arr.start * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = arr.start
    },
    NextDay() {
      const ddd = jalalimoment(this.mapHistoryDateFromFormatted, 'jYYYY/jMM/jDD').unix() + 24 * 60 * 60
      const newd = jalalimoment(ddd * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = newd
    },
    PreviousDay() {
      const ddd = jalalimoment(this.mapHistoryDateFromFormatted, 'jYYYY/jMM/jDD').unix() - 24 * 60 * 60
      const newd = jalalimoment(ddd * 1000).locale('fa').format('YYYY/M/D')
      this.mapHistoryDateFromFormatted = newd
    },
    todayWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(0))
    },
    last7DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(7))
    },
    last30DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(30))
    },
    last60DaysWayPoints() {
      this.getUnixTimeStartEndFormat(this.$functions.lastDaysTimes(60))
    },
    onClickCloseWayPointsSideBar() {
      this.polyline.latlngs = []
      this.searchQuery = ''
      this.deviceInfoBox = true
      this.deviceTracking = false
      this.historySideBarVisible = false
      this.playBackVisible = false

      // TODO: نیاز به بررسی بیشتر دارد و صحیح نیست
      // اما برای رفع عیب موقت هنگام بسته شدن نوار
      // تاریخچه مناسب است
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.$mobileSelectedDevices[0])
      if (deviceInfo && deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
        if (coords) {
          this.setMapCenterAndZoom([coords.lat, coords.lng], 12)
        }
      }

      // مخفی کردن سایر خودروها از روی نقشه به‌صورت موقت
      let list = localStorage.getItem('desktopSelectedDevices')
      if (list !== null) {
        list = JSON.parse(list)
        Object.keys(list)
          .forEach(imei => {
            if (imei in list && list[imei]) {
              const index = Vue.prototype.$functions.getDeviceIndex(imei)
              if ('serverInfo' in Vue.prototype.$devices[index] && 'lat' in Vue.prototype.$devices[index].serverInfo) {
                this.mapMarkers[imei].visible = this.isVisibleMarker(imei, Vue.prototype.$devices[index].serverInfo.lat, Vue.prototype.$devices[index].lon)
              } else {
                this.mapMarkers[imei].visible = false
              }
            }
          })
        this.$forceUpdate()
      }
    },
    getMarkerImei(index) {
      if (this.isMobile && this.selectedImei) {
        return this.selectedImei
      }
      return index
    },
    onMobileMapUndoSetDefaultCenter() {
      this.deviceInfoBox = true
      this.deviceTracking = false

      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.$mobileSelectedDevices[0])
      if (deviceInfo && deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
        if (coords) {
          this.setMapCenterAndZoom([coords.lat, coords.lng], 12)
        }
      }
      this.selectedDevice = null
      // مخفی کردن سایر خودروها از روی نقشه به‌صورت موقت
      let list = localStorage.getItem('desktopSelectedDevices')
      if (list !== null) {
        list = JSON.parse(list)
        Object.keys(list).forEach(imei => {
          if (imei in list && list[imei]) {
            const index = Vue.prototype.$functions.getDeviceIndex(imei)
            if ('serverInfo' in Vue.prototype.$devices[index] && 'lat' in Vue.prototype.$devices[index].serverInfo) {
              this.mapMarkers[imei].visible = this.isVisibleMarker(imei, Vue.prototype.$devices[index].serverInfo.lat, Vue.prototype.$devices[index].lon)
            } else {
              this.mapMarkers[imei].visible = false
            }
          }
        })
        this.$forceUpdate()
      }
    },
    onMobileMapShowHistoryBar() {
      this.mapHistoryDateFromFormatted = ''
      // eslint-disable-next-line prefer-destructuring

      this.historySideBarVisible = true

      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.$mobileSelectedDevices[0])
      if (!deviceInfo) return
      if (deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
        if (coords) {
          this.setMapCenterAndZoom([coords.lat, coords.lng], 16)
        }
      }

      // مخفی کردن سایر خودروها از روی نقشه به‌صورت موقت
      const selectedImei = deviceInfo.imei

      Object.keys(this.mapMarkers).forEach(imei => {
        if (selectedImei !== imei) {
          this.mapMarkers[imei].visible = false
        } else {
          this.mapMarkers[imei].visible = true
        }
      })

      this.todayWayPoints()
    },
    onShowHistoryBar(imei) {
      this.mapHistoryDateFromFormatted = ''
      this.selectedImei = imei
      this.historySideBarVisible = true
      this.todayWayPoints()
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(this.getMarkerImei(index)))
    },
    setMapCenterAndZoom(center, zoom) {
      if (this.$refs.map) {
        if (zoom) {
          this.$refs.map.setZoom(zoom)
        }
        this.$refs.map.setCenter(center)
      }
    },
    isVisibleMarker(imei, lat, lon) {
      let i = 0
      Object.keys(this.mapMarkers)
        .forEach(keyIsImei => {
          if (this.mapMarkers[keyIsImei].visible) {
            i += 1
          }
        })
      return i < Vue.prototype.$functions.getMapLimit() ? this.desktopSelectedDevices[imei] && (lat > 0 || lon > 0) : false
    },
    async addUpdateMarker(marker) {
      const data = marker
      // const isVisible = this.isVisibleMarker(data.imei, data.longitude, data.longitude)
      // console.log(this.desktopSelectedDevices[data.imei])

      const isVisible = this.desktopSelectedDevices[data.imei]

      if (typeof data.imei === 'undefined') {
        return
      }

      const lat = parseFloat(data.latitude)
      const lng = parseFloat(data.longitude)

      if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
        return
      }

      if (data.imei in this.mapMarkers && this.mapMarkers[data.imei] && isVisible) {
        this.lastAngle = this.calcAngle(this.mapMarkers[data.imei].latlng[0], this.mapMarkers[data.imei].latlng[1], lat, lng) + 90
        if (this.lastAngle === 90) {
          this.lastAngle = this.mapMarkers[data.imei].rotationAngle
        }
      } else {
        this.lastAngle = Math.floor(Math.random() * (180 + 1))
      }

      if (this.isMobile && this.selectedDevice === data.imei && isVisible) {
        this.setMapCenterAndZoom([lat, lng], 18)
      }
      this.speed = data.speed
      if (data.speed === '' || data.speed == null) this.speed = 0

      if (isVisible) {
        this.mapMarkers[data.imei] = {
          // علاوه بر اینکه باید برای نمایش انتخاب شده باشد اگر
          // مقادیر مختصاتی نا معتبر داشته باشد هم نباید نمایش داده شود زیرا
          // نقطه نمایش پرت خواهد بود و نامرتبط
          visible: isVisible,
          latlng: [lat, lng],
          rotationAngle: this.lastAngle,
        }
      }
      // this.$forceUpdate()
    },
    modalChangeSim() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeSim({ imei: parseInt(this.device.imei), sim: this.simIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-sim'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalSendSms() {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.device.sim}&body=${this.smsconfigtext}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.device.sim}?body=${this.smsconfigtext}`
        //   window.location.href = `http://127.0.0.1:3232/QXNative/?action=openSmsManager&to=${this.device.sim}&body=${encodeURIComponent(this.smsconfigtext)}`
      }
    },
    modalChangeTitle() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.newtitle, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-name'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeCategory() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.device.title, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-category'].hide()
            this.doFillDevices()
            this.showMarkers()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    hideModal(action) {
      if (action === 'modal-change-sim') {
        this.$refs['modal-change-sim'].hide()
      }
      if (action === 'modal-change-name') {
        this.$refs['modal-change-name'].hide()
      }
      if (action === 'modal-change-category') {
        this.$refs['modal-change-category'].hide()
      }
      if (action === 'modal-send-sms') {
        this.$refs['modal-send-sms'].hide()
      }
    },
    onEditItem(action, item) {
      if (action === 'modal-change-sim') {
        this.device.sim = item.sim.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-sim'].show()
      }
      if (action === 'modal-change-name') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-name'].show()
      }
      if (action === 'modal-change-category') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-category'].show()
      }
      if (action === 'modal-send-sms') {
        this.device.sim = item.sim
        this.device.title = item.title.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-send-sms'].show()
      }
    },
  },
  sockets: {
    reconnect() {
      this.refreshAllPositions()
      Vue.prototype.$socket.emit('devicesOnlineTime', {})
    },
    devicesOnlineTime(imeis) {
      for (const imei in imeis) {
        const index = Vue.prototype.$functions.getDeviceIndex(imei)
        if (Vue.prototype.$devices[index] !== undefined) {
          if (!Vue.prototype.$devices[index].expire) {
            const diff = this.$functions.time() - imeis[imei]
            if (diff > 2 * 60 * 60) { // 2 ساعت - برای آفلاین واقعی
              Vue.prototype.$devices[index].onlineStatus = 'offlineSymbol'
            } else {
              Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
            }
            // serverInfo.servertime را از devicesOnlineTime آپدیت نمی‌کنیم
            // چون مقدار آن با آخرین position واقعی فرق دارد
            // serverInfo.servertime فقط از getPositions() API و devicePosition event می‌آید
          }
        }
      }
      //  this.$root.$emit('forceUpdate', { event: 'socket.devicesOnlineTime', data: imeis })
      // this.$forceUpdate()
    },
    deviceStatus(data) {
      // terminalInfo.gpsTracking
      if ('imei' in data) {
        const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
        if (index >= 0) {
          if (Vue.prototype.$devices[index] !== undefined) {
            if (!Vue.prototype.$devices[index].expire) {
              Vue.prototype.$devices[index].serverStatus = data
              // دریافت هر پکت وضعیت یعنی دستگاه زنده است؛ چراغ آنلاین را همین‌جا تازه کن
              // (قبلاً فقط اسنپ‌شاتِ devicesOnlineTime چراغ را ست می‌کرد و برای خودروی پارک‌شده کهنه می‌ماند)
              Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
              this.$forceUpdate()
            }
          }
        }
      }
    },
    devicePosition(data) {
      // برای غیر موبایل همیشه true هست و برای حالت موبایل
      // بررسی می شود که در صورت وجود در لیست نمایش دهد
      const index = Vue.prototype.$functions.getDeviceIndex(data.imei)

      if (index >= 0) {
        if (Vue.prototype.$devices[index] !== undefined) {
          if (!Vue.prototype.$devices[index].expire) {
            if ('imei' in data) {
              Vue.prototype.$devices[index].serverInfo = data
              // دریافت موقعیت هم یعنی دستگاه زنده است؛ چراغ آنلاین را تازه کن
              Vue.prototype.$devices[index].onlineStatus = 'onlineSymbol'
              this.addUpdateMarker(data)
              this.$forceUpdate()
            }
          }
        }
      }
    },
    deviceReport(data) {
      // if (this.selectedDevice === data.imei){
      this.reportLog += `\n${JSON.stringify(data)}`

      const el = this.$refs.mytextarea
      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollTop = el.scrollHeight
      }
      // }
      // if (data.imei === "351510092235319"){

      // }
      if (data.event.string !== 'login') {
        // console.log(data)
        // console.log(this.selectedDevice)
        // console.log(data.event.string)
      }
    },
  },
}
</script>

<style>
/* لیست خودروها (نسخهٔ جدید) + صفحه‌بندی */
#mapDesktop .dd-list{max-height:calc(100vh - 300px);overflow-y:auto;overflow-x:hidden}
#mapDesktop .dd-pager{position:sticky;bottom:0}
/* چیپ‌های فیلترِ وضعیت */
#mapDesktop .dd-chips{display:flex;flex-wrap:wrap;gap:6px;padding:4px 12px 10px}
#mapDesktop .dd-chip{display:inline-flex;align-items:center;gap:5px;font-size:12px;border:1px solid #ebe9f1;border-radius:20px;padding:5px 11px;color:#6e6b7b;background:#fff;font-family:inherit;cursor:pointer}
#mapDesktop .dd-chip-on{background:#7367f0;color:#fff;border-color:#7367f0}
#mapDesktop .dd-chipdot{width:9px;height:9px;border-radius:50%;display:inline-block}
/* اسکلتونِ لودینگ */
#mapDesktop .dd-loading-head{display:flex;align-items:center;justify-content:center;gap:9px;padding:14px 12px 6px;font-size:12.5px;color:#7367f0}
#mapDesktop .dd-skel{display:flex;align-items:center;gap:11px;padding:14px;border-bottom:1px solid #ebe9f1}
#mapDesktop .dd-skel-ava{width:40px;height:40px;border-radius:50%;flex:none}
#mapDesktop .dd-skel-lines{flex:1;display:flex;flex-direction:column;gap:8px}
#mapDesktop .dd-skel-ava,#mapDesktop .dd-skel-bar{background:linear-gradient(90deg,#eef0f3 25%,#dfe3e9 50%,#eef0f3 75%);background-size:200% 100%;animation:ddshimmer 1.2s linear infinite}
#mapDesktop .dd-skel-bar{height:12px;border-radius:6px}
@keyframes ddshimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
#mapDesktop .dd-pellipsis{color:#9aa0ac;padding:0 2px;align-self:center}
#mapDesktop .dd-empty{padding:34px 20px;text-align:center;color:#9aa0ac}
#mapDesktop .dd-empty-txt{margin:10px 0 0;font-size:13px;color:#9aa0ac}
#mapDesktop .dd-pager{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:6px;padding:12px;border-top:1px solid #ebe9f1;background:#fff}
#mapDesktop .dd-pbtn{min-width:32px;height:32px;border-radius:8px;border:1px solid #ebe9f1;background:#fff;color:#6e6b7b;font-size:13px;font-family:inherit;padding:0 8px;cursor:pointer}
#mapDesktop .dd-pbtn-wide{padding:0 14px}
#mapDesktop .dd-pbtn-on{background:#7367f0;color:#fff;border-color:#7367f0}
#mapDesktop .dd-pbtn:disabled{opacity:.4;cursor:default}
</style>
<style>
[dir=rtl] * {
  font-family: Vazir;
}
nav, .breadcrumbs-top {
  /* display: none !important;*/
}

[dir=rtl] .leaflet-zoom-animated {
  transform-origin:   0% 0% !important;
  -webkit-transform-origin:   0% 0% !important;
  -ms-transform-origin:   0% 0% !important;
}

[dir=rtl] .leaflet-marker-icon {
  transform-origin: center center 0px !important;
}

[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]
.leaflet-layer {
  right: unset !important;
}

.nodiplay .content-header{
  display: none !important;
}
.nodiplay .content-body{
  margin: -47px -27px !important;
}
.nodiplay .horizontal-layout{
  overflow: hidden;
}

[dir=rtl] #mainMap {
  width: calc( 100vw - 400px );
  height: calc( 100vh - 60px );
  direction: ltr !important;
  text-align: left !important;
  padding: 0 !important;
  margin: 0 !important;
  top: 49px !important;
  right: 400px !important;
  position: absolute;
}

.v-data-table__selected td{
  color: #3B7AFF !important;
}

#mapDesktop .deviceRow {
  margin-bottom: 4px;
  width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;
}

#mapDesktop .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.deviceInfo .card-body {
  padding-top: 8px !important;
}
#mapDesktop .card-body {
  padding-top: 0;
  /*
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  */

}

.vpd-input-group input {
  border-radius: 0;
  text-align: center;
}

.vpd-input-group label {
  margin-bottom: 0 !important;
}
@media (min-width: 768px) {
  [dir=rtl] .historySideBar {
    bottom: 0px;
    right: 50vw;
    padding-top: 20px;
  }
}
[dir=rtl] .devicesSideBar{
  top: 50px;
}
[dir=rtl] .devicesSideBar .card-body{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
[dir=rtl] .devicesSideBar {
  height: 100vh;
}
[dir=rtl] .historySideBar, [dir=rtl] .devicesSideBar, [dir=rtl] .deviceInfo , [dir=rtl] .deviceInfoT {
  z-index: 998;
  width: 400px;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
}

.devicesSideBar .card, .devicesSideBar .card-body, .historySideBar .card, .historySideBar .card-body {
  background: #f7f7f7;
}

.deviceRow {
  background: #fff;
}

[dir=rtl] .devicesSideBar {
  right: 0;
}
[dir=rtl] .playBack {
  width: calc( 100vw - 430px);
  left: 15px;
  top: unset;
  position: fixed;
  bottom: 5px;
  height: 82px;
  padding-top: 0px;
  margin-bottom: 0;
  z-index: 999;
}
[dir=rtl] .playBack .card-body{
  padding: 0px !important;
}
.collapse .card-body{
  padding-left: 0.3rem !important;
  padding-right: 0.3rem !important;
}
@media (max-width: 767px) {
  [dir=rtl] #mainMap {
    width: 100vw;
    height: calc( 100% - 55px );
    direction: ltr !important;
    text-align: left !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
    position: absolute;

    right: inherit  !important;
    left: 0 !important;
  }
  [dir="rtl"] .historySideBar, [dir="rtl"] .devicesSideBar , [dir="rtl"] .deviceInfo , [dir="rtl"] .deviceInfoT {
    width: 100%;
  }
  [dir="rtl"] .deviceInfoT {
    background: #eee;
    height: 122px;
    right: 0;
  }
  [dir="rtl"] .devicesSideBar {
    height: calc(100% - 50px);
    top: 0px;
    z-index: 999;
  }
  .leaflet-bottom{
    bottom: unset !important;
    top: 20px;
  }
  .leaflet-control-zoom{
    top: 70px;
  }
  .leaflet-control-zoom a{
    color: gray;
  }
  [dir="rtl"] #mapDesktop .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    height: 70px !important;;
  }
}
.historySideBar-btn{
  display: flex;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.statusSymbol {
  height: 18.6px;
  width: 18.1px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol, .offlineSymbol {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol {
  background-color: #39e340;
}

.offlineSymbol {
  background-color: #b5b5b5;
}

.mobileOnMapHint {
  position: absolute;
  z-index: 999;
  background: rgba(77, 80, 82, 0.89);
  opacity: 0.9;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  color: white;
  font-size: 1rem;
}

.mobileOnMapHintBtns {
  background: none;
}

.mobileOnMapHint button {
  height: 32px;
  width: 32px;
  padding: 0;
  font-size: 1.1rem;
  background: rgb(72, 128, 147) !important;
}

.mobileOnMapHistoryBtn {
  border-radius: 3px;
  padding: 0;
  opacity: 0.8;
  background: unset;
  right: 10px;
  bottom: 50px
}

.mobileOnMapHistoryBtn button {
  text-align: center;
  color: #eee;
  background: #5113db;
}

[dir=rtl] .mobileOnMapHintDeviceTitle {
  top: 10px;
  right: 10px;
}
[dir=rtl] .mobileOnMapHintAddress {
  bottom: 50px;
  right: 50%;
  transform: translate(50%, -50%);
  background: #6a6a6ac4;
  color: #fff;
}

[dir=rtl] .mobileOnMapHintDeviceTime {
  top: 10px;
  left: 10px;
}
[dir=rtl] .mobileOnMapHintHistoryTime {
  bottom: 60px;
  left: 20px;
}
[dir=rtl] .mobileOnMapHintHistorySpeed {
  bottom: 100px;
  right: 10px;
}

[dir=rtl] .mobileOnMapHintMyLocBtn {
  bottom: 120px;
  right: 10px;
}
[dir=rtl] .mobileOnMapHintCrosshairBtn {
  top: 32px;
  left: 5px;
  background: #fff;
  padding: 0px;
  border: 2px solid #d0cfcf;
}

[dir=rtl] .mobileOnMapHintShareBtn {
  bottom: 45px;
  right: 10px;
}

[dir=rtl] #mapDesktop .addDeviceBtn {
  height: 37px;
  width: 38px;
  z-index: 999;
  padding: 0
}
[dir] .btn-secondary:active{
  background-color: unset !important;
}
[dir=rtl] .reportDiv {
  background: #eaeaea !important;
  border: 0px !important;
  bottom: -10px;
  position: absolute;
  left: 15px;
  z-index: 999;
  padding: 0;
  width: 750px;
  height: 150px;font-size: 12px;
}
[dir=rtl] .playBtn {
  cursor: pointer;
  background: #ea121200 !important;
  border: 0px !important;
  top: 20px;
  left: 15px;
  z-index: 999;
  padding: 0
}
[dir=rtl] .closeBtn {
  height: 25px;
  width: 25px;
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
  padding: 0
}

.mapPopup {
  width: 250px;
}

[dir=rtl] .mapPopup p {
  direction: ltr;
  text-align: right;
}

.popup-rtl-row {
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 6px !important;
  direction: rtl !important;
  unicode-bidi: isolate !important;
  vertical-align: middle;
}
.popup-rtl-row strong {
  flex-shrink: 0;
  font-weight: 700;
}
.popup-rtl-row .sat-info,
.popup-rtl-row .bat-info {
  margin: 0 !important;
}

.sat-info, .bat-info {
  display: inline-block;
  font-size: 0.78rem;
  padding: 1px 6px;
  border-radius: 4px;
  font-weight: 600;
  margin-right: 2px;
}
.sat-good    { background: #e6f7ed; color: #186b3a; }
.sat-medium  { background: #fff3e0; color: #b87b1a; }
.sat-bad     { background: #fdecec; color: #962e2e; }
.bat-good    { background: #e6f7ed; color: #186b3a; }
.bat-medium  { background: #fff3e0; color: #b87b1a; }
.bat-low     { background: #fdecec; color: #c63b46; }
.bat-critical{ background: #ea5455; color: #fff; }

.popup-actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  align-items: center;
  margin-top: 4px;
}
.popup-actions .btn {
  padding: 4px 10px;
  font-size: 0.72rem;
  line-height: 1.2;
  margin: 0;
}
.popup-actions .btn.btn-icon {
  padding: 4px 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.leaflet-control-attribution {
  display: none;
}

.vpd-wrapper {
  z-index: 999 !important;
}
.rounded-circle{
  color: #fff !important;
}
#mapDesktop .vpd-icon-btn{
  display: none !important;
}
[dir=rtl] #mapDesktop .v-data-table td {
  font-size: 11px !important;
}
[dir=rtl] #mapDesktop .v-data-table > .v-data-table__wrapper > table > tbody > tr > td > div{
  padding: 20px 2px;

}
[dir=rtl] #mapDesktop .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0px !important;
  height: 80px;
  border: none;
  color: #4a597a;
}

[dir=rtl] #mapDesktop .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 0px !important;
  line-height: 0px;
  height: 10px;
  color: #4a597a;
}

[dir=rtl] #mapDesktop .v-data-table td .mdi-checkbox-blank-outline,  [dir=rtl] #mapDesktop .v-data-table th .mdi-checkbox-blank-outline{
  font-size: 15px !important;
  color: rgba(0, 0, 0, 0.87)!important;
}
[dir="rtl"] .v-input--selection-controls__ripple{

}
.v-menu{
  display: block !important;
}

.v-menu__content {
  font-size: 12px !important;
  opacity: 1 !important;
  background: #fff !important;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}

[dir] .leaflet-tooltip{
  padding: 1px 3px !important;
  border-radius: 8px;
}

#mapDesktop .v-data-table tr{

}

#mapDesktop thead.v-data-table-header {
  display: none;
}
</style>
